<template>
    <div>
        <div class="fluid-container featured-image">
            <div class="container">
                <div class="featured-text">
                    <span class="feature-content">
                        <p class="feature-header">Excellent Service</p>
                        <p class="feature-header">At Competitive</p>
                        <p class="feature-header">Rates</p>
                        <div class="buttons">
                            <router-link class="services-button" to="/our-services/">See&nbsp;Our&nbsp;Services</router-link>
                            <a class="contact-button" href="tel:07950189260">Call&nbsp;now</a>
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="fluid-container">
            <div class="row no-gutters">
                <div class="offset-xl-2 col-xl-4 col-md-12 welcome-section">
                        <h1 class="welcome-header">We pride ourselves on our reliability...</h1>
                        <hr align="left">
                        <p>All of our licensed drivers and vehicles are available for booking 7 days a week, 365 days a year.</p>
                        <p>Feel free to book any time of day or night if booked in advance.</p>
                        <p>No matter how long or short the journey, Harling Taxis Ltd are always there to help.</p>
                    <p><strong>Please do not hesitate, get in touch with us now and receive a very quick reply by one of our helpful operators.</strong></p>
                </div>
                <div class="col-xl-6 welcome-image">
                </div>
            </div>
        </div>
        <div class="container-fluid contact-us-bg py-1">
            <div class="fluid-container contact-us-section">
                <div class="row align-items-center">
                    <div class="col-lg-6 offset-lg-2 col-sm-12">
                        <p>We take great pride in being your go to taxi company, delivering a fast and friendly service to Harling and surrounding areas all year round.</p>
                    </div>
                    <div class="col-lg-3 col-sm-12">
                        <div class="contact-button">
                            <router-link to="/contact-us/" >Contact Us Today</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container my-4" id="testimonials">
            <div class="row no-gutters justify-content-center">
                <div class="col-1">
                    <open-quote/>
                </div>
                <div class="col-10 align-self-center my-4 px-0">
                    <swiper :options="swiperOption" class="col-sm-10 quote-content mx-0">
                        <!-- slides -->
                        <swiper-slide>
                            <div class="col-sm-10">
                                <p>I always use Harling Taxis. Good rates and friendly drivers, would definitely recommend.</p>
                                <br>
                                <p><b>Aaron Grime</b></p>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="col-sm-10 quote-content">
                                <p>Excellent company. Always friendly and reliable!</p>
                                <br>
                                <p><b>Adam Greenwood</b></p>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="col-sm-10 quote-content">
                                <p>Thank you for your efficient and professional service when an elderly client found herself unexpectedly without transport. We will always recommend you’.</p>
                                <br>
                                <p><b>Karen Lawrence</b></p>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="col-sm-10 quote-content">
                                <p>Thank you!!! Very friendly driver and the person I spoke to on the phone was very helpful. Will definitely be using you again!</p>
                                <br>
                                <p><b>Jess Issit</b></p>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="col-sm-10 quote-content">
                                <p>Reliable, always on time and very polite.</p>
                                <br>
                                <p><b>Mandy Pinnock</b></p>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="col-1 align-self-end">
                    <close-quote/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import OpenQuote from '../partials/OpenQuote'
import CloseQuote from '../partials/CloseQuote'

export default {
  components: {
    CloseQuote,
    OpenQuote,
    swiper,
    swiperSlide
  },
  name: 'Home',
  data () {
    return {
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Home.vue